import axios from 'axios';
import { debug } from 'debug';
import { getReasonPhrase, StatusCodes } from 'http-status-codes';
import { HTTPRequestError, WrappedResponse } from '../../models/http';
import { OPERATION_ROUTE } from '../configs/operation-api';
import {
	SocialGetPostsRequestInterface,
	SocialGetPostsResponseInterface,
} from '../models/operation-get-posts';
import { toDateString } from '../utils/string-formatters';

export const getPosts = async (
	payload: SocialGetPostsRequestInterface,
): Promise<SocialGetPostsResponseInterface> => {
	if (payload.from instanceof Date) payload.from = toDateString(payload.from);
	if (payload.to instanceof Date) payload.to = toDateString(payload.to);

	const response = await axios.post<
		WrappedResponse<SocialGetPostsResponseInterface>
	>(OPERATION_ROUTE.GET_POSTS, payload);

	if (response.status !== StatusCodes.OK) {
		debug(`Error: ${response.status}`);
		throw new HTTPRequestError(getReasonPhrase(response.status));
	}

	return response.data.responsePayload;
};
